export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';

export const LOADING = 'LOADING';

export const LOAD_INFO = 'LOAD_INFO';



// WEBPACK FOOTER //
// ./src/redux/actions.type.js